<script setup lang="ts">
import useEmblaCarousel from 'embla-carousel-vue'
import { onMounted, ref, useTemplateRef } from 'vue'

const OPTIONS = { dragFree: true, loop: false }
const [emblaRef, emblaApi] = useEmblaCarousel(OPTIONS)

const isUserDragging = ref(false)

const emblaBtnPrev = useTemplateRef<HTMLElement>('emblaBtnPrev')
const emblaBtnNext = useTemplateRef<HTMLElement>('emblaBtnNext')

onMounted(() => {
  if (!emblaApi.value) return

  emblaBtnNext.value?.addEventListener('click', () => {
    emblaApi.value?.scrollNext()
  })

  emblaBtnPrev.value?.addEventListener('click', () => {
    emblaApi.value?.scrollPrev()
  })

  emblaApi.value.on('pointerDown', () => {
    isUserDragging.value = true
  })

  emblaApi.value.on('pointerUp', () => {
    isUserDragging.value = false
  })
})
</script>

<template>
  <div class="py-10 pl-2xl flex flex-col xl:grid grid-cols-12 gap-16">
    <div class="flex flex-col gap-10 col-span-5">
      <div class="px-3 py-5 border-b-5 border-Tertiary max-w-35/50">
        <span class="text-H2 text-Tekst">Pokój jednoosobowy</span>
      </div>
      <span class="text-H4 text-Tekst">
        Dla osób, które cenią kameralny pobyt.
      </span>
      <div class="flex flex-row gap-5 items-center">
        <NuxtImg
          src="https://api.ostoja-seniora.pl/files/icon-8.svg"
          height="45"
          width="45"
          loading="lazy"
          quality="100"
          alt="chair"
          class="object-contain"
        />
        <div class="border-b border-Tertiary">
          <span class="text-H4 text-Tekst font-semibold">Wyposażenie pokoju</span>
        </div>
      </div>
      <span class="text-H4 text-Tekst">
        profesjonalne łóżko rehabilitacyjne <br>
        szafa<br>
        stół i krzesła<br>
        telewizor<br>
        prywatna łazienka wyposażona w uchwyty i udogodnienia dla osób z ograniczoną sprawnością, zaprojektowana tak, żeby codzienne czynności były bezpieczne i komfortowe<br>
        system przywoływania personelu, który działa całą dobę
      </span>
      <div class="flex flex-col gap-5">
        <span class="text-Tekst text-Paragraph">
          Chcesz zobaczyć pokój na żywo? Przyjedź, rozejrzyj się i poczuj jak tu jest.
        </span>
        <div class="hidden xl:flex flex-col">
          <span class="text-Tekst">Umów się na spotkanie</span>
          <span class="text-H4 font-semibold text-Tekst">+48 887 040 560</span>
        </div>
        <AppButton
          href="tel:+48887040560"
          button-theme="Primary"
          class="xl:hidden flex"
        >
          <div class="flex flex-col xl:flex-row gap-2 items-center">
            <span class="">Umów się na spotkanie</span>
            <span class="text-H4 font-semibold">+48 887 040 560</span>
          </div>
        </AppButton>
      </div>
    </div>
    <div class="xl:pt-24 col-span-7">
      <div class="flex flex-col gap-6 sticky top-40">
        <div class="embla">
          <div
            ref="emblaRef"
            class="overflow-hidden"
          >
            <div
              class="flex gap-8 select-none"
            >
              <div class="embla__slide basis-8/10 xl:basis-4/5 shrink-0 h-full">
                <NuxtImg
                  src="https://api.ostoja-seniora.pl/files/img-12.png"
                  width=""
                  height=""
                  quality="100"
                  loading="lazy"
                  alt=""
                  class="rounded-3xl"
                />
              </div>
              <div class="embla__slide basis-8/10 xl:basis-4/5 shrink-0 h-full">
                <NuxtImg
                  src="https://api.ostoja-seniora.pl/files/img-12.png"
                  width=""
                  height=""
                  quality="100"
                  loading="lazy"
                  alt=""
                  class="rounded-3xl"
                />
              </div>
              <div class="embla__slide basis-8/10 xl:basis-4/5 shrink-0 h-full">
                <NuxtImg
                  src="https://api.ostoja-seniora.pl/files/img-12.png"
                  width=""
                  height=""
                  quality="100"
                  loading="lazy"
                  alt=""
                  class="rounded-3xl"
                />
              </div>
              <div class="embla__slide basis-8/10 xl:basis-4/5 shrink-0 h-full">
                <NuxtImg
                  src="https://api.ostoja-seniora.pl/files/img-12.png"
                  width=""
                  height=""
                  quality="100"
                  loading="lazy"
                  alt=""
                  class="rounded-3xl"
                />
              </div>
              <div class="embla__slide basis-8/10 xl:basis-4/5 shrink-0 h-full">
                <NuxtImg
                  src="https://api.ostoja-seniora.pl/files/img-12.png"
                  width=""
                  height=""
                  quality="100"
                  loading="lazy"
                  alt=""
                  class="rounded-3xl"
                />
              </div><div class="embla__slide basis-8/10 xl:basis-4/5 shrink-0 h-full">
                <NuxtImg
                  src="https://api.ostoja-seniora.pl/files/img-12.png"
                  width=""
                  height=""
                  quality="100"
                  loading="lazy"
                  alt=""
                  class="rounded-3xl"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="flex items-start">
          <div class="flex flex-row ">
            <div
              ref="emblaBtnPrev"
              class="px-7.5 py-5 border border-r-0 border-Tekst rounded-l-full transition-all duration-200 group group-hover:border-Secondary cursor-pointer"
            >
              <i class="pi pi-arrow-left text-Tekst group-hover:text-Secondary text-2xl! transition-all duration-200" />
            </div>
            <div
              ref="emblaBtnNext"
              class="px-7.5 py-5 border border-l-0 border-Tekst rounded-r-full transition-all duration-200 group group-hover:border-Secondary cursor-pointer"
            >
              <i class="pi pi-arrow-right text-Tekst group-hover:text-Secondary text-2xl! transition-all duration-200" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
